// extracted by mini-css-extract-plugin
export default {"root":"Privacy_root__urUrd","link":"Privacy_link__OIxtn","Privacy":"Privacy_Privacy__JbXw7"};